import { Link } from "react-router-dom";
import GlobeIcon from "../../../icons/globeIcon";
import FeaturesCard from "./FeaturesCard";
import ClockIcon from "../../../icons/clockIcon";
import ShipIcon from "../../../icons/shipIcon";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white">
      <div className="flex flex-wrap items-center justify-center w-11/12 gap-16 mx-auto">
        <FeaturesCard
          Icon={GlobeIcon}
          header={t("everyWhere")}
          text={t("whereEverYouAre")}
          Link={
            <Link to="/services" className="font-bold text-mainRed underline-link">
              {t("ReadMore")}
            </Link>
          }
        />
        <FeaturesCard
          Icon={ClockIcon}
          header={t("fastestService")}
          text={t("24hAvailability")}
          Link={
            <Link to="/services" className="font-bold text-mainRed underline-link">
              {t("ReadMore")}
            </Link>
          }
        />
        <FeaturesCard
          Icon={ShipIcon}
          header={t("shipsForRent")}
          text={t("weProvide")}
          Link={
            <Link
              to="/contact-us"
              className="px-2 py-3 font-bold text-white rounded-lg bg-mainRed hover:bg-mainRed/90"
            >
              {t("subscribeToNewsLetter")}
            </Link>
          }
        />
      </div>
    </article>
  );
};

export default Features;
